<div class="landing-status" fxLayout="row" fxLayoutAlign="center center">
  <div class="status-top" fxFlex="90" fxFlex.gt-lg="80" fxLayoutAlign="left top">
    <div class="status-top__tabs" [fxFlex]="this?.fromLanding === 'customer' ? '70' : '80'">
      <mat-tab-group
        class="tabmenu"
        *ngIf="transactionTypes?.length > 0"
        [selectedIndex]="getIndex()"
        (selectedTabChange)="selectedTabChange($event)"
        (selectChange)="selectedTabChange($event)">
        <mat-tab *ngFor="let transaction of transactionTypes">
          <ng-template mat-tab-label>
            <div class="tabmenu__label">{{ transaction.label }}</div>
            <div class="tabmenu__value">{{ transaction.value }}</div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="status-top__create" fxFlex="20" *ngIf="this?.fromLanding === 'main'; else customerLanding">
      <button id="new-invoice-button" [disabled]="disableNewInvoice()"
        (click)="showCreateInvoiceModal()">
        <mat-icon>add_circle</mat-icon>
        <span i18n>New Invoice</span>
      </button>
    </div>
    <ng-template #customerLanding>
      <div class="status-top__create" fxFlex="15">
        <button id="create-customer-button" [disabled]="disableNewInvoice()"
          (click)="createNewCustomer()">
          <mat-icon>add_circle</mat-icon>
          <span i18n>New Customer</span>
        </button>
      </div>
      <div class="status-top__create" fxFlex="15">
        <button id="update-customer-button" [disabled]="disableNewInvoice()"
          (click)="updateCustomer()">
          <mat-icon>add_circle</mat-icon>
          <span i18n>Update Customer</span>
        </button>
      </div>
    </ng-template>
  </div>
</div>
